import React, { useState, useEffect } from "react";
import { Container, Form, Button } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

const EditCategory = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    id: "",
    name: "",
    description: "",
    status: "",
    image: "",
  });

  const [imagePreview, setImagePreview] = useState(null);
  const [newImage, setNewImage] = useState(null);

  //alert(id);
  useEffect(() => {
    fetch(`https://ecom-api.applligentdemo.com/category/getById/${id}`, {
      headers: {
        Authorization: localStorage.getItem("token"),
      },
    })
      .then((res) => {
        if (!res.ok) throw new Error("Network response was not ok");
        return res.json();
      })
      .then((data) => {
        const category = data.category;
        setFormData({
          id: category._id,
          name: category.name,
          description: category.description,
          status: category.status === true ? "Active" : "Inactive",
          image: category.image,
        });

        if (category.image) {
          setImagePreview(category.image);
        }
      })
      .catch((err) => {
        toast.error("Failed to load category");
      });
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setNewImage(file);
      setImagePreview(URL.createObjectURL(file));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const form = new FormData();
      form.append("id", formData._id);
      form.append("name", formData.name);
      form.append("description", formData.description);
      form.append("status", formData.status === "Active");
      if (newImage) {
        form.append("image", newImage);
      }
      const res = await fetch(
        `https://ecom-api.applligentdemo.com/category/updateCategory`,
        {
          method: "POST",
          headers: {
            Authorization: localStorage.getItem("token"),
          },
          body: form
        }
      );
      
      if (res.ok) {
        toast.success("Category updated");
        navigate("/category");
      } else {
        toast.error("Failed to update");
      }
    } catch (err) {
      toast.error("Something went wrong");
    }
  };

  return (
    <Container className="mt-5">
      <Button variant="secondary" onClick={() => navigate(-1)}>
        ← Back
      </Button>
      <h2 className="mb-4">Edit Category</h2>
      <Form onSubmit={handleSubmit}>
        <Form.Group className="mb-3">
          <Form.Label>Category Name</Form.Label>
          <Form.Control
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Description</Form.Label>
          <Form.Control
            as="textarea"
            name="description"
            value={formData.description || ""}
            onChange={handleChange}
          />
        </Form.Group>

        <Form.Group controlId="status" className="mb-3">
          <Form.Label>Status</Form.Label>
          <Form.Select
            name="status"
            value={formData.status || "Active"}
            onChange={handleChange}
          >
            <option value="Active">Active</option>
            <option value="Inactive">Inactive</option>
          </Form.Select>
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Image</Form.Label>
          <Form.Control type="file" onChange={handleImageChange} />
          {imagePreview && (
            <img
              src={imagePreview}
              alt="Preview"
              style={{
                width: "100px",
                height: "100px",
                objectFit: "cover",
                marginTop: "10px",
              }}
            />
          )}
        </Form.Group>

        <Button variant="success" type="submit">
          Update Category
        </Button>
      </Form>
    </Container>
  );
};

export default EditCategory;
